var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row nav"},[_c('router-link',{staticClass:"tab four columns",attrs:{"to":{name:'Admin'},"exact":""}},[_vm._v("カード管理")]),_c('router-link',{staticClass:"tab four columns",attrs:{"to":{name:'UserAdmin'},"exact":""}},[_vm._v("ユーザー追加・編集")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }